const PRODUCTION_HOSTNAME = "partners.creso.in";
const SIGNUP_CONVERSION_SEND_TO = "AW-17519338435/hAU5CI-tnsQcEMPH76FB";

function waitForGtagReady() {
  return window.__gtagReady ?? Promise.resolve();
}

export function reportSignupConversion(
  onComplete: () => void,
  transactionId: string
): Promise<void> {
  return new Promise((resolve) => {
    const finish = () => {
      onComplete();
      resolve();
    };

    if (window.location.hostname !== PRODUCTION_HOSTNAME) {
      finish();
      return;
    }

    waitForGtagReady().then(() => {
      const { gtag } = window;

      if (typeof gtag !== "function") {
        finish();
        return;
      }

      let done = false;
      const complete = () => {
        if (done) return;
        done = true;
        finish();
      };

      window.setTimeout(complete, 2000);

      gtag("event", "conversion", {
        send_to: SIGNUP_CONVERSION_SEND_TO,
        value: 1.0,
        currency: "INR",
        transaction_id: transactionId,
        event_callback: complete,
      });
    });
  });
}
